
import Block from 'Mixins/Block';
import utils from 'Utils/utils';

export default Block('component-input', {
	fn: {
		validate (event) {

			const input 	= event.target;
			const component = input.closest('.component-input');

			if (utils.isNotEmptyString(input.value)) {

				component.classList.add('component-input--touched');

			}

		},
		handleInput (event) {

			const input 	= event.target;
			const component = input.closest('.component-input');

			if (utils.isNotEmptyString(input.value)) {

				component.classList.add('component-input--has-value');

			} else {

				component.classList.remove('component-input--has-value');

			}

		},
		handleClick (event) {

			const component = event.target.closest('.component-input');
			const input 	= component.querySelector('input, textarea');

			input.value = '';
			component.classList.remove('component-input--touched');
			component.classList.remove('component-input--has-value');

		}
	},
	onLoad (qComponent) {

		qComponent.forEach(node => {

			const input = node.querySelector('input, textarea');
			const clear = node.querySelector('.component-input__clear');

			if (input) {

				input.addEventListener('blur', this.fn.validate, false);
				input.addEventListener('keyup', this.fn.handleInput, false);

			}

			if (clear) {

				clear.addEventListener('click', this.fn.handleClick, false);

			}

		});

	}
});
